const FormResources = {

    form_data:{
        group_id:       '',
        name:           '',
        description:    '',
        start_salary:   '',
        end_salary:     '',
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Group:',
            model_name: 'group_id',
            ref:        'group_id_input',
            ref_alt:    'group_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       'any',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Start salary:',
            model_name: 'start_salary',
            ref:        'start_salary_input',
            ref_alt:    'start_salary_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'End Salary:',
            model_name: 'end_salary',
            ref:        'end_salary_input',
            ref_alt:    'end_salary_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },

    ]

}

export default FormResources;